/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Orders_Search_PlaceholderInputs */

const vi_kiotviet_orders_search_placeholder = /** @type {(inputs: Kiotviet_Orders_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo mã đơn, tên khách...`)
};

/**

* @param {Kiotviet_Orders_Search_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_orders_search_placeholder = /** @type {((inputs?: Kiotviet_Orders_Search_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Orders_Search_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_orders_search_placeholder(inputs)
});